import React from "react";
// import { Link, Redirect, useHistory } from "react-router-dom";
// import { Button, Form } from "react-bootstrap";
// import Slider from "react-slick";
// import HomeBanner from "./../../images/main-slider/new_home_banner.jpg";
// import firstBanner from "./../../images/home_icon/Home 1.jpg";
// import secondBanner from "./../../images/home_icon/Home 2.jpg";
// import thirdBanner from "./../../images/home_icon/Home 3.jpg";
// import fourthBanner from "./../../images/home_icon/Home 4.jpg";
import playStore from "./../../images/play-store.png";
import appStore from "./../../images/app_store.png";
import finalImage from "./../../images/new-updated-images/home/home-banner-latest.jpg";
// import { redirectUrl } from "../../services/GlobalUrls";
// import { jobSectorList } from "../../services/JobTypeAndSectorGlobalList";
import Jobfindbox from "./Jobfindbox";
// import { allJobs } from "../../services/Data";

// const postBlog = [
//   {
//     image: firstBanner,
//     content:
//       "Very well run and organised team. Easy to use web site. Louise always available to answer questions. I have regular work since last 4 months and happy to recommend.",
//     owner: "Simone Butler",
//   },
//   {
//     image: secondBanner,
//     content:
//       "Great to work for Staffing Connect. Jobs are easy to accept. Any queries they are answered swiftly. Once timesheets are completed and submitted, payroll makes weekly payments. ",
//     owner: "Cathy Thomas",
//   },
//   {
//     image: thirdBanner,
//     content:
//       "Really easy Sign-up process. DBS was done in 2 days. Booked onto shifts really quickly so started to earn straight away. Enjoyed the nursery assistant work. Very happy.",
//     owner: "Laura Blundell",
//   },
//   {
//     image: fourthBanner,
//     content:
//       "Fantastic flexible work options & get paid on weekly basis. Lots of variety of roles that you're matched to. No trawling through irrelevant jobs just the ones that meet your criteria.",
//     owner: "Suzanne Brown",
//   },
// ];

const IndexBannerComponent = ({ callArray }) => {
  return (
    <>
      <div
        className="dez-bnr-inr content-inner-2 dez-bnr-inr-md overlay-black-middle"
        style={{
          backgroundImage: `url(${finalImage})`,
        }}
      >
        <div className="container ">
          <div className="dez-bnr-inr-entry align-m">
            <div className="find-job-bx">
              <Jobfindbox
                allJobs={callArray}
                filteredJobs={callArray}
                isHomePage={true}
                // handleSubmit={handleSubmit}
              />
              <center>
                <a
                  href="https://play.google.com/store/apps/details?id=com.ittrp.staffing_connect"
                  target="_blank"
                >
                  <img
                    src={playStore}
                    alt="Download on Google Play"
                    id="playStore"
                    className="img-fluid appImage"
                  />
                </a>
                <a
                  href="https://apps.apple.com/app/staffing-connect/id6449247669"
                  target="_blank"
                >
                  <img
                    src={appStore}
                    id="appStore"
                    alt="Download on the App Store"
                    className="img-fluid appImage"
                  />
                </a>
              </center>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default IndexBannerComponent;
